import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ModalService } from '../../../../../services/modal.service';
import { QuickLinkService } from '../../../../../services/quick-link.service';
import { DigiTrainerContent } from '../../../../../models/digi-trainer-content';
import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { DigiTrainerLink } from '../../../../../models/digi-trainer-link';
import { ModalComponent } from '../../../../../models/modal-component';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import { SafeHtmlPipe } from '../../../../../pipes/safe-html.pipe';

declare const MathJax;
export const DIGI_TRAINER_COOKIE_NAME = 'digiTrainerLastOpened';

@Component({
    selector: 'app-digi-trainer-modal',
    templateUrl: './digi-trainer-modal.component.html',
    styleUrls: ['./digi-trainer-modal.component.scss'],
    imports: [
        AssetPipe,
        SafeHtmlPipe
    ],
    standalone: true
})
export class DigiTrainerModalComponent extends ModalComponent implements OnInit, OnDestroy {
    static MODAL_ID = DigiTrainerContent.MODAL_ID;
    digiTrainerContent: DigiTrainerContent;
    lastOpenedAssignments: Array<string>;
    private subscription: Subscription;

    private modalService = inject(ModalService);
    private quicklinkService = inject(QuickLinkService);
    cookieService = inject(CookieService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.subscription = this.quicklinkService.digiTrainerContent$.subscribe(content => {
            this.digiTrainerContent = content;
            setTimeout(() => {
                MathJax.Hub.Queue(['Typeset', MathJax.Hub]);
                MathJax.Hub.Config({ CommonHTML: { scale: 100 } });
            }, 1000);
        });

        if (this.cookieService.check(DIGI_TRAINER_COOKIE_NAME)) {
            this.lastOpenedAssignments = JSON.parse(this.cookieService.get(DIGI_TRAINER_COOKIE_NAME));
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    getId(): string {
        return DigiTrainerModalComponent.MODAL_ID;
    }

    quicklinkClick(assignments: Array<string>, title?: string): void {
        this.modalService.closeModal('digiTrainerModal');
        const link = new DigiTrainerLink();
        link.link = assignments.join(',');

        this.cookieService.set(DIGI_TRAINER_COOKIE_NAME, JSON.stringify(assignments), null, null, null, true);
        this.lastOpenedAssignments = assignments;

        this.modalService.openModal(link);
    }
}
